import React from "react";
const InputFormFile = ({style,event,name,onChange}) => {
    return (
        <input class={style} name={name} type={'file'}  onChange={onChange}/>
    )
}
export default InputFormFile;

